import React from 'react'
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export default function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        console.log(`GA send event = ${location.pathname} ${location.search}`)
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname + location.search,
        });
    }, [location]);

    return null;
}